export const FETCH_MODEL = 'FETCH_MODEL';
export const FETCH_MODEL_SUCCESS = 'FETCH_MODEL_SUCCESS';
export const FETCH_MODEL_ERROR = 'FETCH_MODEL_ERROR';
export const fetchModel = (id) => ({ type: FETCH_MODEL, payload: id });

export const FETCH_MODELS = 'FETCH_MODELS';
export const fetchModels = () => ({ type: FETCH_MODELS });

export const FETCH_MODELS_SUCCESS = 'FETCH_MODELS_SUCCESS';
export const fetchModelsSuccess = () => ({ type: FETCH_MODELS_SUCCESS });

export const FETCH_MODELS_ERROR = 'FETCH_MODELS_ERROR';
export const fetchModelsError = () => ({ type: FETCH_MODELS_ERROR });

export const SAVE_MODEL = 'SAVE_MODEL';
export const saveModel = (payload) => ({ type: SAVE_MODEL, payload });

export const SAVE_MODEL_SUCCESS = 'SAVE_MODEL_SUCCESS';
export const saveModelSuccess = () => ({ type: SAVE_MODEL_SUCCESS });

export const SAVE_MODEL_ERROR = 'SAVE_MODEL_ERROR';
export const saveModelError = () => ({ type: SAVE_MODEL_ERROR });

export const DESIGN_MODEL = 'DESIGN_MODEL';
export const DESIGN_MODEL_ERROR = 'DESIGN_MODEL_ERROR';
export const DESIGN_MODEL_SUCCESS = 'DESIGN_MODEL_SUCCESS';
export const designModel = (payload) => ({ type: DESIGN_MODEL, payload });

export const DESIGN_MODEL_INIT_STATE = 'DESIGN_MODEL_INIT_STATE';
export const designModelInitState = (payload) => ({ type: DESIGN_MODEL_INIT_STATE, payload });

export const DESIGN_MODEL_CANCEL = 'DESIGN_MODEL_CANCEL';
export const designModelCancel = () => ({ type: DESIGN_MODEL_CANCEL });

export const GENERATE_ENDPOINTS_CONFIRM = 'GENERATE_ENDPOINTS_CONFIRM';
export const GENERATE_ENDPOINTS = 'GENERATE_ENDPOINTS';
export const GENERATE_ENDPOINTS_STARTED = 'GENERATE_ENDPOINTS_STARTED';
export const GENERATE_ENDPOINTS_ERROR = 'GENERATE_ENDPOINTS_ERROR';
export const GENERATE_ENDPOINTS_SUCCESS = 'GENERATE_ENDPOINTS_SUCCESS';
export const confirmGenerateEndpoints = (payload) => ({
	type: GENERATE_ENDPOINTS_CONFIRM,
	payload });
export const generateEndpoints = (payload) => ({ type: GENERATE_ENDPOINTS, payload });
